import React from 'react'

function Loading () {
  return (
    <div className="text-center">
        <div className="sp sp-3balls"> </div>
        <h5> Loading... </h5>
    </div>
  )
}

export default Loading



/** WEBPACK FOOTER **
 ** ./app/components/Loading.js
 **/